import { render, staticRenderFns } from "./ChatAssistant.vue?vue&type=template&id=604c8dd8&scoped=true&"
import script from "./ChatAssistant.vue?vue&type=script&lang=js&"
export * from "./ChatAssistant.vue?vue&type=script&lang=js&"
import style0 from "./ChatAssistant.vue?vue&type=style&index=0&id=604c8dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c8dd8",
  null
  
)

export default component.exports